"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LimitTypes = void 0;
var LimitTypes;
(function (LimitTypes) {
    LimitTypes["NONE"] = "NONE";
    LimitTypes["AMOUNT"] = "AMOUNT";
    LimitTypes["TIME"] = "TIME";
})(LimitTypes = exports.LimitTypes || (exports.LimitTypes = {}));
//# sourceMappingURL=limit-settings.js.map